@use "variables" as *;

.mainContent {
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.toolbar {
  padding-left: $spacing-s;
  padding-right: $spacing-s;
}

.title {
  font-size: $fontSize-l;
  margin: $spacing-s;
}

.appBar {
  height: $appBarHeight;
}

.mainBody {
  display: flex;
  height: calc(100% - #{$appBarHeight});
}

.attributeListContainer {
  width: $attribute-list-width;
}

.attributeDetail {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.noSelectionDiv {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: $spacing-xl;
  overflow: auto;
}

.shortcutsTitle {
  font-size: $fontSize-ml;
  font-weight: bold;
  margin: $spacing-s $spacing-s $spacing-xl $spacing-s;
  text-align: center;
}

.shortcutsGrid {
  padding-left: $spacing-xxl;
  padding-right: $spacing-xxl;
}

.credits {
  margin-top: -$spacing-m;
  margin-right: $spacing-m;
}
